import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "display-element-order-bonus-details-preview" }
const _hoisted_2 = { class: "display-element-order-bonus-details-preview__bullet-list" }
const _hoisted_3 = {
  key: 0,
  class: "display-element-order-bonus-details-preview__link"
}
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = {
  key: 1,
  class: "display-element-order-bonus-details-preview__additional-text"
}
const _hoisted_6 = {
  key: 0,
  class: "display-element-order-bonus-details-preview__additional-text-content"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4 mb-4" }, null, -1)
const _hoisted_8 = {
  key: 2,
  class: "display-element-order-bonus-details-preview__configuration-form"
}
const _hoisted_9 = {
  key: 3,
  class: "display-element-order-bonus-details-preview__price-info"
}
const _hoisted_10 = {
  key: 4,
  class: "display-element-order-bonus-details-preview__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCommandLink = _resolveComponent("IconCommandLink")!
  const _component_IconShowMore = _resolveComponent("IconShowMore")!
  const _component_ComplexOrderBonusConfigurationSelectionForm = _resolveComponent("ComplexOrderBonusConfigurationSelectionForm")!
  const _component_BasicButton = _resolveComponent("BasicButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderBonus.infoPoints, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
      }), 128))
    ]),
    (_ctx.orderBonus.link && _ctx.orderBonus.linkLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("a", {
            href: _ctx.orderBonus.link,
            title: _ctx.orderBonus.linkLabel,
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            _createVNode(_component_IconCommandLink),
            _createTextVNode(" " + _toDisplayString(_ctx.orderBonus.linkLabel), 1)
          ], 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderBonus.text && _ctx.orderBonus.textLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["display-element-order-bonus-details-preview__additional-text-label", {
          'display-element-order-bonus-details-preview__additional-text-label--active':
            _ctx.showAdditionalText,
        }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAdditionalText = !_ctx.showAdditionalText))
          }, [
            _createVNode(_component_IconShowMore, {
              "is-closed": !_ctx.showAdditionalText
            }, null, 8, ["is-closed"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.orderBonus.textLabel), 1)
          ], 2),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.showAdditionalText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.orderBonus.text), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_7,
    (_ctx.showOrderBonusConfigurationForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_ComplexOrderBonusConfigurationSelectionForm, {
            "order-bonus": _ctx.orderBonus,
            "configuration-selection-options": _ctx.orderBonusConfigurationOptions,
            "chosen-values": _ctx.chosenValues,
            disabled: _ctx.orderBonusIsInCart,
            onConfigurationChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('configurationChanged', $event)))
          }, null, 8, ["order-bonus", "configuration-selection-options", "chosen-values", "disabled"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPriceInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.commonText.userFrontend.orderBonusSelectionView
          .detailPreviewPriceInfoLabel), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.priceInfo), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isInteractive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_BasicButton, {
            variant: "primary",
            type: "submit",
            "no-arrow": "",
            disabled: _ctx.disabledButton,
            class: "mt-0 btn-save btn-primary--blank",
            onButtonClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('orderBonusSelected', _ctx.orderBonus.materialNumber)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}